import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { Divider as AntDivider } from 'antd';
import styled from 'styled-components';
var Divider = styled(AntDivider)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.ant-divider {\n    margin: 1rem 0;\n    background: ", ";\n  }\n"])), function (props) {
  return props.theme.colors.grey;
});
export default Divider;